import type { NotificationsRecord } from '@libs/data-access/entities'
import type { ReduxState } from '@spa/redux/ReduxState'
import Immutable from 'immutable'

export const getNotifications = (state: ReduxState): NotificationsRecord =>
  state.notifications.get('data', Immutable.Map())
